import GameBG_entertainment_0001 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0001.jpg';
import GameBG_entertainment_0002 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0002.jpg';
import GameBG_entertainment_0003 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0003.jpg';
import GameBG_entertainment_0004 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0004.jpg';
import GameBG_entertainment_0005 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0005.jpg';
import GameBG_entertainment_0006 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0006.jpg';
import GameBG_entertainment_0007 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0007.jpg';
import GameBG_entertainment_0008 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0008.jpg';
import GameBG_entertainment_0009 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0009.jpg';
import GameBG_entertainment_0010 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0010.jpg';
import GameBG_entertainment_0011 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0011.jpg';
import GameBG_entertainment_0012 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0012.jpg';
import GameBG_entertainment_0013 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0013.jpg';
import GameBG_entertainment_0014 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0014.jpg';
import GameBG_entertainment_0015 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0015.jpg';
import GameBG_entertainment_0016 from '../assets/graphics/jpeg/gameBackground/GameBG_entertainment_0016.jpg';

import challenge_bg1_1450x667 from '../assets/graphics/png/background/challenge_bg1_1450x667.png';
import challenge_bg2_1450x667 from '../assets/graphics/png/background/challenge_bg2_1450x667.png';
import competition_bg1_1450x667 from '../assets/graphics/png/background/competition_bg1_1450x667.png';
import Competition_BG_Stadium from '../assets/graphics/png/background/Competition_BG_Stadium.png';
import handwriting_game_bg1_1450x667 from '../assets/graphics/png/background/handwriting_game_bg1_1450x667.png';
import handwriting_game_bg1_667x1450 from '../assets/graphics/png/background/handwriting_game_bg1_667x1450.png';
import handwriting_game_bg2_1450x667 from '../assets/graphics/png/background/handwriting_game_bg2_1450x667.png';
import handwriting_game_bg2_667x1450 from '../assets/graphics/png/background/handwriting_game_bg2_667x1450.png';
import handwriting_game_bg3_1450x667 from '../assets/graphics/png/background/handwriting_game_bg3_1450x667.png';
import handwriting_game_bg3_667x1450 from '../assets/graphics/png/background/handwriting_game_bg3_667x1450.png';
import listening_game_bg01_1450x667 from '../assets/graphics/png/background/listening_game_bg01_1450x667.png';
import listening_game_bg01_667x1450 from '../assets/graphics/png/background/listening_game_bg01_667x1450.png';
import listening_game_bg02_1450x667 from '../assets/graphics/png/background/listening_game_bg02_1450x667.png';
import listening_game_bg02_667x1450 from '../assets/graphics/png/background/listening_game_bg02_667x1450.png';
import matching_game_bg2_1450x667 from '../assets/graphics/png/background/matching_game_bg2_1450x667.png';
import matching_game_bg2_667x1450 from '../assets/graphics/png/background/matching_game_bg2_667x1450.png';
import matching_game_bg_1450x667 from '../assets/graphics/png/background/matching_game_bg_1450x667.png';
import matching_game_bg_667x1450 from '../assets/graphics/png/background/matching_game_bg_667x1450.png';
import multiple_choice_game_bg2_1450x667 from '../assets/graphics/png/background/multiple_choice_game_bg2_1450x667.png';
import multiple_choice_game_bg2_667x1450 from '../assets/graphics/png/background/multiple_choice_game_bg2_667x1450.png';
import multiple_choice_game_bg_1450x667 from '../assets/graphics/png/background/multiple_choice_game_bg_1450x667.png';
import multiple_choice_game_bg_667x1450 from '../assets/graphics/png/background/multiple_choice_game_bg_667x1450.png';
import speaking_game_bg1_1450x667 from '../assets/graphics/png/background/speaking_game_bg1_1450x667.png';
import speaking_game_bg1_667x1450 from '../assets/graphics/png/background/speaking_game_bg1_667x1450.png';
import speaking_game_bg2_1450x667 from '../assets/graphics/png/background/speaking_game_bg2_1450x667.png';
import speaking_game_bg2_667x1450 from '../assets/graphics/png/background/speaking_game_bg2_667x1450.png';
import speaking_game_bg3_1450x667 from '../assets/graphics/png/background/speaking_game_bg3_1450x667.png';
import speaking_game_bg3_667x1450 from '../assets/graphics/png/background/speaking_game_bg3_667x1450.png';
import spelling_game_bg1_1450x667 from '../assets/graphics/png/background/spelling_game_bg1_1450x667.png';
import spelling_game_bg1_667x1450 from '../assets/graphics/png/background/spelling_game_bg1_667x1450.png';
import spelling_game_bg2_1450x667 from '../assets/graphics/png/background/spelling_game_bg2_1450x667.png';
import spelling_game_bg2_667x1450 from '../assets/graphics/png/background/spelling_game_bg2_667x1450.png';
import spelling_game_bg3_1450x667 from '../assets/graphics/png/background/spelling_game_bg3_1450x667.png';
import spelling_game_bg3_667x1450 from '../assets/graphics/png/background/spelling_game_bg3_667x1450.png';
import word_game_bg1_1450x667 from '../assets/graphics/png/background/word_game_bg1_1450x667.png';
import word_game_bg1_667x1450 from '../assets/graphics/png/background/word_game_bg1_667x1450.png';
import word_game_bg2_1450x667 from '../assets/graphics/png/background/word_game_bg2_1450x667.png';
import word_game_bg2_667x1450 from '../assets/graphics/png/background/word_game_bg2_667x1450.png';
import { MultiplayerGameType } from './EntertainmentGames/multiplayerGame';

type GameTheme = {
  themeTypes: ThemeType[];
  themes: Theme[];
};

enum GameType {
  TextOrdering = 'textOrdering',
  Ordering = 'ordering',
  Conversation = 'conversation',
  ManuallyEvaluatedConversation = 'manuallyEvaluatedConversation',
  Speaking = 'speaking',
  MultipleChoice = 'multipleChoice',
  Matching = 'matching',
  FingerWriting = 'fingerWriting',
  Pairing = 'pairing',
}

type ThemeType =
  | 'competition'
  | 'challenge'
  | GameType
  | MultiplayerGameType
  | { imageOrSet: string[] };

interface Theme {
  portraitBackground: string;
  landscapeBackground: string;
  plate?: PNGIcon;
  primaryColor?: Color;
  secondaryColor?: Color;
}

// enum FileSource {}
// // URLs or paths to the image files

enum PNGIcon {
  Plate1 = 'plate1',
  Plate2 = 'plate2',
  // Define other possible icons
}

enum Color {
  Gray150 = 'gray150',
  // Define other colors
}

export const gameThemes: GameTheme[] = [
  {
    themeTypes: ['competition'],
    themes: [
      {
        portraitBackground: competition_bg1_1450x667,
        landscapeBackground: Competition_BG_Stadium,
      },
    ],
  },
  {
    themeTypes: ['challenge'],
    themes: [
      {
        portraitBackground: challenge_bg1_1450x667,
        landscapeBackground: challenge_bg1_1450x667,
      },
      {
        portraitBackground: challenge_bg2_1450x667,
        landscapeBackground: challenge_bg2_1450x667,
      },
    ],
  },
  {
    themeTypes: [
      GameType.TextOrdering,
      GameType.Ordering,
      GameType.Conversation,
      GameType.ManuallyEvaluatedConversation,
      GameType.Speaking,
    ],
    themes: [
      {
        portraitBackground: speaking_game_bg1_667x1450,
        landscapeBackground: speaking_game_bg1_1450x667,
      },
      {
        portraitBackground: speaking_game_bg2_667x1450,
        landscapeBackground: speaking_game_bg2_1450x667,
      },
      {
        portraitBackground: speaking_game_bg3_667x1450,
        landscapeBackground: speaking_game_bg3_1450x667,
      },
      {
        portraitBackground: spelling_game_bg1_667x1450,
        landscapeBackground: spelling_game_bg1_1450x667,
      },
      {
        portraitBackground: spelling_game_bg2_667x1450,
        landscapeBackground: spelling_game_bg2_1450x667,
      },
      {
        portraitBackground: spelling_game_bg3_667x1450,
        landscapeBackground: spelling_game_bg3_1450x667,
      },
      {
        portraitBackground: word_game_bg1_667x1450,
        landscapeBackground: word_game_bg1_1450x667,
      },
      {
        portraitBackground: word_game_bg2_667x1450,
        landscapeBackground: word_game_bg2_1450x667,
      },
    ],
  },
  {
    themeTypes: [GameType.MultipleChoice, GameType.Matching],
    themes: [
      {
        portraitBackground: matching_game_bg_667x1450,
        landscapeBackground: matching_game_bg_1450x667,
      },
      {
        portraitBackground: matching_game_bg2_667x1450,
        landscapeBackground: matching_game_bg2_1450x667,
      },
      {
        portraitBackground: multiple_choice_game_bg_667x1450,
        landscapeBackground: multiple_choice_game_bg_1450x667,
      },
      {
        portraitBackground: multiple_choice_game_bg2_667x1450,
        landscapeBackground: multiple_choice_game_bg2_1450x667,
      },
    ],
  },
  {
    themeTypes: [GameType.FingerWriting],
    themes: [
      {
        portraitBackground: handwriting_game_bg1_667x1450,
        landscapeBackground: handwriting_game_bg1_1450x667,
      },
      {
        portraitBackground: handwriting_game_bg2_667x1450,
        landscapeBackground: handwriting_game_bg2_1450x667,
      },
      {
        portraitBackground: handwriting_game_bg3_667x1450,
        landscapeBackground: handwriting_game_bg3_1450x667,
      },
    ],
  },
  {
    themeTypes: [GameType.Pairing],
    themes: [
      {
        portraitBackground: listening_game_bg01_667x1450,
        landscapeBackground: listening_game_bg01_1450x667,
      },
      {
        portraitBackground: listening_game_bg02_667x1450,
        landscapeBackground: listening_game_bg02_1450x667,
      },
    ],
  },
  {
    themeTypes: [
      MultiplayerGameType.JOYAChess,
      MultiplayerGameType.FiveLoavesTwoFish,
      MultiplayerGameType.TicTacToe,
      MultiplayerGameType.Gomoku,
      MultiplayerGameType.Go,
      MultiplayerGameType.Chess,
      MultiplayerGameType.ChineseChess,
    ],
    themes: [
      {
        portraitBackground: GameBG_entertainment_0001,
        landscapeBackground: GameBG_entertainment_0001,
      },
      {
        portraitBackground: GameBG_entertainment_0002,
        landscapeBackground: GameBG_entertainment_0002,
      },
      {
        portraitBackground: GameBG_entertainment_0003,
        landscapeBackground: GameBG_entertainment_0003,
      },
      {
        portraitBackground: GameBG_entertainment_0004,
        landscapeBackground: GameBG_entertainment_0004,
      },
      {
        portraitBackground: GameBG_entertainment_0005,
        landscapeBackground: GameBG_entertainment_0005,
      },
      {
        portraitBackground: GameBG_entertainment_0006,
        landscapeBackground: GameBG_entertainment_0006,
      },
      {
        portraitBackground: GameBG_entertainment_0007,
        landscapeBackground: GameBG_entertainment_0007,
      },
      {
        portraitBackground: GameBG_entertainment_0008,
        landscapeBackground: GameBG_entertainment_0008,
      },
      {
        portraitBackground: GameBG_entertainment_0009,
        landscapeBackground: GameBG_entertainment_0009,
      },
      {
        portraitBackground: GameBG_entertainment_0010,
        landscapeBackground: GameBG_entertainment_0010,
      },
      {
        portraitBackground: GameBG_entertainment_0011,
        landscapeBackground: GameBG_entertainment_0011,
      },
      {
        portraitBackground: GameBG_entertainment_0012,
        landscapeBackground: GameBG_entertainment_0012,
      },
      {
        portraitBackground: GameBG_entertainment_0013,
        landscapeBackground: GameBG_entertainment_0013,
      },
      {
        portraitBackground: GameBG_entertainment_0014,
        landscapeBackground: GameBG_entertainment_0014,
      },
      {
        portraitBackground: GameBG_entertainment_0015,
        landscapeBackground: GameBG_entertainment_0015,
      },
      {
        portraitBackground: GameBG_entertainment_0016,
        landscapeBackground: GameBG_entertainment_0016,
      },
    ],
  },
];

export function getDefaultMultiplayerGameTypeBackground(
  gameType: MultiplayerGameType,
): string {
  for (const item of gameThemes) {
    const index = item.themeTypes.indexOf(gameType);
    if (index !== -1 && index < item.themes.length) {
      // Safe access check
      const theme = item.themes[index];
      if (theme) {
        return theme.landscapeBackground;
      }
    }
  }
  return '';
}
